import React from 'react'
import { Link } from 'react-router-dom'
import { ALERT_TYPES } from '../Alert/constants'

/**
 * Banner Configurations
 *
 * Defines all banners shown in the application.
 * Banners are displayed in priority order - first to last.
 * Only the first active banner that hasn't been dismissed will be shown.
 *
 * When a user dismisses a banner, the next banner in the list will
 * automatically appear if its conditions are met.
 *
 * Available alert types: ALERT_TYPES.WARNING, ALERT_TYPES.DANGER, ALERT_TYPES.SUCCESS, ALERT_TYPES.INFO
 */

/**
 * Get banner configurations
 *
 * @param {Object} system - Current system object from AuthContext
 * @returns {Array} Array of banner configuration objects
 */
export function getBannerConfigs(system) {
  return [
    {
      id: 'monitoring',
      show: system.is_owner && system.resource.show_enphase_link_button,
      type: ALERT_TYPES.WARNING,
      message: (
          <>
            Please link your online monitoring account. <Link to="/" style={{ textDecoration: 'underline' }}>Click Here</Link>
          </>
      ),
      storageKey: 'banner-monitoring-dismissed'
    },
    // Add more banner configurations here
    // They will show sequentially after previous ones are dismissed
    //
    // Example with plain text:
    // {
    //   id: 'simple-message',
    //   show: true,
    //   type: ALERT_TYPES.INFO,
    //   message: 'This is a simple text message',
    //   storageKey: 'banner-simple-dismissed'
    // }
    //
    // Example with internal link (underlined, navigates to app page):
    // {
    //   id: 'profile-incomplete',
    //   show: !user.profile_completed,
    //   type: ALERT_TYPES.INFO,
    //   message: (
    //     <>
    //       Please <Link to="/account" style={{ textDecoration: 'underline' }}>complete your profile</Link> to continue
    //     </>
    //   ),
    //   storageKey: 'banner-profile-dismissed'
    // }
    //
    // Example with external link:
    // {
    //   id: 'help',
    //   show: true,
    //   type: ALERT_TYPES.SUCCESS,
    //   message: (
    //     <>
    //       Check out our <a href="https://docs.example.com" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline' }}>documentation</a> for more info
    //     </>
    //   ),
    //   storageKey: 'banner-help-dismissed'
    // }
  ]
}
